import { type Locale } from 'date-fns';
import {
  ca,
  cs,
  da,
  de,
  deAT,
  enAU,
  enCA,
  enGB,
  enIE,
  enIN,
  enNZ,
  enUS,
  es,
  eu,
  fi,
  fr,
  frCA,
  frCH,
  gl,
  hr,
  hu,
  it,
  itCH,
  ja,
  ko,
  nb,
  nl,
  nlBE,
  pl,
  pt,
  ro,
  sk,
  sl,
  srLatn,
  sv,
} from 'date-fns/locale';

const LOCALES = {
  ca,
  cs,
  da,
  de,
  deAT,
  enAU,
  enCA,
  enGB,
  enIE,
  enIN,
  enNZ,
  enUS,
  es,
  eu,
  fi,
  fr,
  frCA,
  frCH,
  gl,
  hr,
  hu,
  it,
  itCH,
  ja,
  ko,
  nb,
  nl,
  nlBE,
  pl,
  pt,
  ro,
  sk,
  sl,
  sr: srLatn,
  sv,
};

export const getLocale = (): Locale => {
  let languageCountry = `${CSS_CONFIG.language}${CSS_CONFIG.country.toUpperCase()}`;
  if (CSS_CONFIG.language === 'no') {
    languageCountry = 'nb';
  }
  let localeIndex = Object.keys(LOCALES).indexOf(languageCountry);
  if (localeIndex < 0) {
    localeIndex = Object.keys(LOCALES).indexOf(CSS_CONFIG.language);
  }
  if (localeIndex >= 0) {
    return Object.values(LOCALES)[localeIndex] as Locale;
  }
  return enUS;
};
